<!-- eslint-disable -->
<template lang="pug">
    div
        .app-header__full-size-block(v-show="showButtons")
        app-header
            .app-header__left-block(
                slot="left",
                :class="{'app-header__left-block--without-button': !isMenuButtonDisplayed}"
            )
                .app-header__menu-icon(v-if="isMenuButtonDisplayed", @click="$emit('toggleSidebar')")
                    svg-icon(name="open-menu", size="xxx-large")
                router-link.app-header__logo-container(:to="{name: 'dashboard'}")
                    img.app-header__logo(src="../../assets/images/logo.svg")
            .app-header__center-block(v-if="user && isMenuButtonDisplayed", slot="center")
                .profiles-button(
                    v-if="user.type !== 'student' && user.type !== 'olympiad-student'"
                )
                    cs-button(
                        :key="showButtons"
                        color="white"
                        pattern="primary-outline"
                        @click.self="showControlButtons"
                        :class="{'profiles-button_active': showButtons}"
                    )
                        |  {{ $i18n.t('dashboard.dashboard_sidebar_profiles') }}
                        svg-icon(:name="iconName" size="large")
                .app-header__block-control-buttons
                    transition-group(name="slide-fade")
                        control-buttons.app-header__control-buttons(
                            v-if="showButtons"
                            :button-color="'green'"
                            :key="'controlButtonsBox'"
                        )
                div(:class="{'app-header__control-buttons_only': user.type !== 'student' && user.type !== 'olympiad-student' }")
                    control-buttons
            .app-header__right-block(slot="right", :class="{'app-header__right-block--visible': isGameHeaderVisible}")
                .profile(v-if="user && !isGameHeaderVisible")
                    dropdown(:header="true")
                        .profile__link(slot="link")
                            | {{ user.firstName }}
                        template(slot="after-icon")
                            img.avatar(:src="user.avatar")
                        ul.dropdown__links
                            li.dropdown__link
                                router-link(:to="{name: 'user:profile', params: {id: user.id, type: user.type}}")
                                    | {{ $i18n.t('dashboard.dashboard_appHeader_menuPage') }}
                            li.dropdown__link
                                router-link(:to="{name: 'user:edit', params: {id: user.id, type: user.type}}")
                                    | {{ $i18n.t('dashboard.dashboard_appHeader_menuOptions') }}
                            li.dropdown__link
                                a(href="javascript://" @click="logOut")
                                    | {{ $i18n.t('dashboard.dashboard_appHeader_menuExit') }}
                .game-header(v-if="isGameHeaderVisible")
                    portal-target(name="game-header")
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex'
    import AppHeader from '../../elements/AppHeader.vue'
    import Dropdown from '../../elements/Dropdown.vue'
    import ControlButtons from './ControlButtons.vue'

    export default {
        props: {
            isMenuButtonDisplayed: {
                type: Boolean,
                default: true
            }
        },
        mounted () {
            this.addControlButtonsBehavior();
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            isGameHeaderVisible () {
                return this.$route.name.includes(':start') || this.$route.name === 'abacus';
            },
            iconName() {
                return this.showButtons ? 'small-angle-up' : 'small-angle-down';
            }
        },
        data () {
            return {
                isModalOpened: false,
                showButtons: false
            }
        },
        methods: {
            logOut () {
                window.localStorage.setItem('locale', this.user.locale);
                this.$router.push({name: 'dashboard'});
                this.$store.dispatch('logOut');
            },
            showControlButtons: _.debounce( function () {
                this.showButtons = !this.showButtons;
            }, 100),
            addControlButtonsBehavior () {
                if (window.innerWidth > 1199 && window.innerWidth < 1440) {
                    let mainContent = document.getElementsByClassName('app-header__full-size-block')[0];
                    this.addClickAwayEventListenerToElement(mainContent);
                }
            },
            addClickAwayEventListenerToElement (element) {
                let mc = new Hammer.Manager(element);
                let Tap = new Hammer.Tap({
                    taps: 1
                });
                mc.add(Tap);
                mc.on('tap', () => {
                    this.showControlButtons();
                });
            }
        },
        components: {
            ControlButtons,
            Dropdown,
            AppHeader,
        }
    }
</script>

<style lang="scss" scoped>
    .profile {
        display: flex;
        justify-content: flex-end;
        width: 100%;
    }

    .profile__link {
        text-align: right;
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
    }

    .avatar {
        border-radius: 50%;
        height: 60px;
        width: 60px;
        margin-left: 14px;
        border: 6px solid rgba($hsl-color-gray-100, 0.2);
    }

    .app-header__link {
        flex: 0;
    }

    .app-header__logo-container {
        display: flex;
    }

    .app-header__logo {
        max-width: none;
        width: 228px;
        height: 41px;
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }

    .app-state {
        position: absolute;
        font-size: 1rem;
        line-height: 2.5rem;
        color: $x-color-black;
        background: rgba($hsl-color-gray-100, 0.9);
        width: 100%;
        @include media($md) {
            font-size: 2rem;
            line-height: 5rem;
        }
    }

    .button__icon {
        display: inline-block;
        margin-left: $space-x-small;
    }

    .app-header__menu-icon {
        display: block;
        color: $hsl-color-green-58;
        @include media($md) {
            display: none;
        }
    }

    .app-header__left-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include media($md) {
            padding-right: 42px;
        }
    }

    .app-header__left-block--without-button {
        justify-content: flex-end;
    }

    .app-header__center-block {
        display: none;
        @include media($xlg) {
            display: block;
        }
    }

    .app-header__right-block {
        display: none;
        @include media($md) {
            display: block;
        }
        &--visible {
            display: block;
        }
    }

    .profiles-button {
        display: none;
        background-color: transparent;
        position: relative;
        @media screen and (min-width: 1200px) and (max-width: 1439px) {
            display: flex;
            .svg-icon {
                margin-left: 5px;
            }
        }
        &:hover {
            box-shadow: 0 0 15px $hsl-color-gray-82;
        }
    }

    .profiles-button_active {
        color: $x-color-black !important;
        background-color: $x-color-white !important;
        border-radius: 40px;
        cursor: pointer;
    }

    .app-header__block-control-buttons {
        display: none;
        @media screen and (min-width: 1200px) and (max-width: 1439px) {
            display: flex;
        }
        position: absolute;
        top: 100px;
        z-index: 1000;
    }

    .app-header__control-buttons {
        height: 325px;
        width: 226px;
        position: relative;
        flex-direction: column !important;
        justify-content: space-evenly;
        background-color: $x-color-white;
        box-shadow: 0 0 5px $x-color-black;
        border-radius: 12px;
        padding: 10px 15px;
        &::after, &::before {
            content: '';
            position: absolute;
            background: $x-color-white;
            left: 20px;
            top: -6px;
            width: 14px;
            height: 14px;
            z-index: -1;
            box-shadow: -2.5px -2.5px 1px rgba(80, 80, 80, 0.3);
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            transition: box-shadow .4s ease;
        }
        &::before {
            z-index: 999;
            box-shadow: none;
        }
    }

    .app-header__control-buttons_only {
        display: flex;
        @media screen and (min-width: 1200px) and (max-width: 1439px) {
            display: none;
        }
    }

    .app-header__full-size-block {
        z-index: 10;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        right: 0;
        @media screen and (max-width: 1199px) and (min-width: 1440px) {
            display: none;
        }
    }

    .slide-fade-enter-active, {
        transition: all .4s ease;
    }
    .slide-fade-leave-active {
        transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateY(-10px);
        opacity: 0;
    }

</style>
